module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/single-company-dashboard-page/single-company-dashboard-page.component.scss
// module id = ./src/app/onboarding/components/single-company-dashboard-page/single-company-dashboard-page.component.scss
// module chunks = main